export default "__VITE_ASSET__ZSScpp6N__"